import { ClipboardCopy } from "shared/pipes/clipboard-copy";
import { TitleSection } from "../headers";
import { InfoSection } from "../headers";

const FeedbackTransformer = ({ children }) => {
    const icons = {
        "Liked it": <i className="fas is-large fa-thumbs-up has-text-success"></i>,
        "Loved it": <i className="fas is-large fa-heart has-text-info"></i>,
        "Didn't like it": <i className="fas is-large fa-thumbs-down has-text-danger"></i>
    };

    const texts = {
        "Liked it": 'Liked',
        "Loved it": 'Loved',
        "Didn't like it": 'Disliked'
    };

    return (
        <small>
            <span className="icon-text">
                <span className="icon">
                    {icons[children]}
                </span>
                <span className="is-hidden-mobile">{texts[children]}</span>
            </span>
        </small>
    );
}

const Footer = ({ item }) => {
    if (item.barcode === "not_picked_up") {
        return null;
    }
    if (!item.feedback) {
        return (
            <footer className="card-footer">
                <p className="card-footer-item">
                    <small>
                        <span className="icon-text">
                            <span className="icon is-hidden-mobile">
                                <i className="fas fa-clock"></i>
                            </span>
                            <span>No feedback yet</span>
                        </span>
                    </small>
                </p>
            </footer>
        );
    }

    return (
        <footer className="card-footer">
            <p className="card-footer-item">
                <FeedbackTransformer>{item.feedback}</FeedbackTransformer>
            </p>
            <p className="card-footer-item">
                <small>
                    <span>{item.size_feedback}</span>
                </small>
            </p>
        </footer>
    )
}

const ItemFigure = ({ item, box, withStatus = false }) => {
    return (
        <div id={item.barcode}>
            <TitleSection item={item} />
            <InfoSection item={item} box={box} withStatus={withStatus} />
            <div className="card-image">
                <ClipboardCopy value={item.barcode}>
                    <figure className="image">
                        <img src={item.imageURL} alt={item.barcode} />
                    </figure>
                </ClipboardCopy>
            </div>

            <Footer item={item} />
        </div>
    );
}

export { ItemFigure as ViewItemFigure };
